import type { ReactNode } from 'react';

import { Logo } from './Logo';
import { Switcher } from './Switcher';

/**
 * El marco compartido por login, registro y las pantallas de contraseña.
 *
 * `showSwitcher` existe por el registro: ahí el idioma y el tema son campos
 * del formulario, y tener dos controles para lo mismo en la misma pantalla
 * confunde y se desincroniza.
 */
export function AuthLayout({
  children,
  showSwitcher = true,
}: {
  children: ReactNode;
  showSwitcher?: boolean;
}): JSX.Element {
  return (
    <div className="page">
      <main className="card">
        {/* El logo, arriba de todo y solo: es la primera pantalla que ve
            alguien que no conoce el producto, y acá sí lleva texto
            alternativo porque no hay nada más que diga de quién es esto. */}
        <p className="brand-hero">
          {/*
            96 Y NO 44. El logo de esta versión de la marca es APILADO: la
            «R» arriba y la palabra debajo, que ocupa como un cuarto del
            alto. A 44 la palabra quedaba de once píxeles — ilegible en la
            única pantalla donde el logo tiene que decir de quién es esto.
          */}
          <Logo variant="full" size={96} alt="Tennis Up Club" />
        </p>
        {children}
      </main>

      {/* AL FINAL: ver el comentario de `Switcher`. En el registro no van,
          porque ahí el idioma y el tema son campos del formulario y dos
          controles para lo mismo en la misma pantalla se desincronizan. */}
      {showSwitcher && <Switcher />}
    </div>
  );
}
